export var ignoreErrors = [
    /您取消了请求/g,
    /Request failed with status code 4/g,
    /Request failed with status code 5/g,
    /ResizeObserver/g,
    'ResizeObserver loop limit exceeded',
    /Cannot read properties of undefined \(reading \'Q\'\)/,
    /Cannot read properties of null \(reading \'removeChild\'\)/,
    /Cannot read property \'Q\' of undefined/,
    /Cannot read property \'removeChild\' of null/,
    /promise rejection captured/g,
    'ChunkLoadError',
    /Loading( CSS)? chunk (.+) failed/g,
    /Cannot read property 'path' of undefined/g,
    /WebViewJavascriptBridge/g // 忽略桥接库报错
];
